// extracted by mini-css-extract-plugin
module.exports = {"viewIcon":"expirationActionButtons_viewIcon__10AEp"};